import { BaseProvider } from '../sdk/BaseProvider';
import { noProviderCapabilities } from '../sdk/ProviderCapabilities';
import type { ProviderMetadata } from '../sdk/ProviderMetadata';
export class SkeletonProvider extends BaseProvider {
  constructor(metadata: Omit<ProviderMetadata, 'environment' | 'sdkVersion'>) {
    super({ ...metadata, environment: 'sandbox', sdkVersion: '0.5.14-alpha.1' }, noProviderCapabilities());
  }
}
